import { render, staticRenderFns } from "./fButton.template?vue&type=template&id=4e8bc9a5&scoped=true&lang=pug&"
import script from "./fButton.client?vue&type=script&lang=ts&"
export * from "./fButton.client?vue&type=script&lang=ts&"
import style0 from "./fButton.component.vue?vue&type=style&index=0&id=4e8bc9a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8bc9a5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/flypaper/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e8bc9a5')) {
      api.createRecord('4e8bc9a5', component.options)
    } else {
      api.reload('4e8bc9a5', component.options)
    }
    module.hot.accept("./fButton.template?vue&type=template&id=4e8bc9a5&scoped=true&lang=pug&", function () {
      api.rerender('4e8bc9a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/widgets/fButton/fButton.component.vue"
export default component.exports